"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNestedValueFromParentValueBySlug = exports.getValueFromRecordBySlug = void 0;
/**
 * @deprecated
 * The direct use of this function is unsafe because the value in the record may be wrong/invalid.
 * Use `getValueFromRecordByField` instead.
 */
const getValueFromRecordBySlug = (record, field) => {
    if (record === undefined)
        return undefined;
    if (record === null)
        return undefined;
    return record[field.slug];
};
exports.getValueFromRecordBySlug = getValueFromRecordBySlug;
const getNestedValueFromParentValueBySlug = (parentValue, nestedFieldSlug) => {
    if (parentValue === undefined)
        return undefined;
    if (parentValue === null)
        return undefined;
    if (Array.isArray(parentValue)) {
        return parentValue.map((item) => item[nestedFieldSlug]);
    }
    try {
        return parentValue[nestedFieldSlug];
    }
    catch (_a) {
        return undefined;
    }
};
exports.getNestedValueFromParentValueBySlug = getNestedValueFromParentValueBySlug;
